import { render, staticRenderFns } from "./OverAllPieChart.vue?vue&type=template&id=541d0c8b&"
import script from "./OverAllPieChart.vue?vue&type=script&lang=js&"
export * from "./OverAllPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports